import React from 'react'
import { TEMPORAL_FILTERS } from '../../data/constants';
import { classIf, getFilterDesc, getFilterDescWithLive } from '../../data/utils';
import PrematchContext from '../../contexts/PrematchContext';


function WidgetFasceOrarie() {
    const prematchContext = React.useContext(PrematchContext);
    const currentFilter = prematchContext.temporalFilter;

  return (
    <>
          <div className="widgetFasce__wrapper">
          <h3 className='widgetFasce__title'>Calendario</h3>
                                        {TEMPORAL_FILTERS.map((filter, i) => {
                                          

                                            function handleClick() {
                                                if(filter === 'LIVE'){
                                                    window.location.href = '/live-suite';
                                            }
                                            else{
                                                prematchContext.setTemporalFilter(filter);

                                            }
                                            }
                                            console.log(filter)
                                            return (
                                                <span key={i} className={"fascia pointer widgetFasce__timing" + classIf(currentFilter === filter, 'f-attiva')} onClick={handleClick}>{getFilterDescWithLive(filter)}</span>
                                            );
                                        })}
                                    </div>
    </>
  )
}

export default WidgetFasceOrarie